import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";

export class AvisDeVirementLigne {
    id?: number;
    avis_de_virement_id?: number;
    copropriete_id?: number;
    copropriete_name?: string;
    copropriete_ref?: string;
    copropriete_nom?: string;
    numero_facture?: string;
    date_facture?: string;
    libelle?: string;
    montant?: number;
    numero_virement?: string;
    // Rapprochement bancaire
    operation_bancaire_id?: number;
    operation_date?: string;
    operation_libelle?: string;

    constructor(data: any) {
        _.assign(this, data);
    }

    get date_facture_str(): string {
        if (this.date_facture) {
            return DateUtils.sqlToDateStr(this.date_facture, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get operation_date_str(): string {
        if (this.operation_date) {
            return DateUtils.sqlToDateStr(this.operation_date, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get copropriete_link(): string {
        return "#/app/client/" + this.copropriete_id;
    }

    serialize(): AvisDeVirementLigne.IAvisDeVirementLigne {
        return {
            id: this.id,
            copropriete_id: this.copropriete_id,
            copropriete_name: this.copropriete_name,
            copropriete_ref: this.copropriete_ref,
            numero_facture: this.numero_facture,
            date_facture: this.date_facture,
            libelle: this.libelle,
            montant: this.montant,
            numero_virement: this.numero_virement,
        };
    }
}

// Interface for serialization
export namespace AvisDeVirementLigne {
    export interface IAvisDeVirementLigne {
        id?: number;
        copropriete_id?: number;
        copropriete_name?: string;
        copropriete_ref?: string;
        numero_facture?: string;
        date_facture?: string;
        libelle?: string;
        montant?: number;
        numero_virement?: string;
    }
}
